import { render, staticRenderFns } from "./SchoolSubjectList.vue?vue&type=template&id=201c5332"
import script from "./SchoolSubjectList.vue?vue&type=script&lang=js"
export * from "./SchoolSubjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports